import {FormControl, FormGroup} from "@angular/forms";
import {FermeturePonctuelleDTO} from "../../../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleDTO";
import {Component, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {FermeturePoncutelleService} from "../../../../core/services/entities/fermeture-poncutelle.service";
import {JourFerieDTO} from "../../../../core/dtos/fermeture-ponctuelle/JourFerieDTO";
import {PerimetreFermetureDTO} from "../../../../core/dtos/fermeture-ponctuelle/PerimetreFermetureDTO";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {TagBoxComponent} from "../../../../shared/ui/tag-box/tag-box.component";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {ActivatedRoute} from "@angular/router";
import {UniteDeProductionDTO} from "../../../../core/dtos/unite-de-production-dto";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-up-fermetures-ponctuelles-edition-dialog',
  templateUrl: './up-fermetures-ponctuelles-edition-dialog.component.html',
  styleUrls: ['./up-fermetures-ponctuelles-edition-dialog.component.scss'],
  standalone: false
})
export class UpFermeturesPonctuellesEditionDialogComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  @ViewChild("perimetresFermeturesTag") perimetresFermeturesTag: TagBoxComponent;

  @Input() public uniteProduction: UniteDeProductionDTO;

  subOpenDialog: Subscription;
  subRoute: Subscription;

  fermeturePonctuelle: FermeturePonctuelleDTO = new FermeturePonctuelleDTO();
  jourFerieList: JourFerieDTO[] = [];
  perimetreFermetureList: PerimetreFermetureDTO[] = [];
  selectedPerimetreFermetureList: string[];
  selectedJourFerie: string;
  selectedDatefermeture: Date;
  form: FormGroup = new FormGroup({});

  dialogTitle: string = 'Modification d\'une fermeture ponctuelle';
  displayDialog: boolean = false;

  constructor(private utilsSvc: UtilsService,
              private toastSvc: ToastService,
              private fermeturePonctuelleSvc: FermeturePoncutelleService,
              private route: ActivatedRoute
  ) {
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
    this.utilsSvc.unsubscribe(this.subRoute);
  }

  ngOnInit(): void {
    this.initForm();
    this.openDialogEditionSubscription();
  }


  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.fermeturePonctuelleSvc.openDialogEdition$
      .subscribe((fermeturePonctuelle: FermeturePonctuelleDTO) => {
        this.displayDialog = true;
        if (!fermeturePonctuelle) {
          this.fermeturePonctuelle = new FermeturePonctuelleDTO();
          this.fermeturePonctuelle.id = null;
          this.dialogTitle = 'Création d\'une fermeture ponctuelle';
        } else {
          this.fermeturePonctuelle = fermeturePonctuelle;
          this.dialogTitle = 'Modification d\'une fermeture ponctuelle';
        }
        this.initJourFerie();
        this.initPerimetreFermeture();
        this.initForm();
      });
  };

  initForm = (): void => {
    this.selectedDatefermeture = this.fermeturePonctuelle?.dateFermeture;
    this.selectedPerimetreFermetureList = this.fermeturePonctuelle?.perimetreFermetureList?.map(p => p.code);
    this.form = new FormGroup({
      libelle: new FormControl(this.fermeturePonctuelle?.libelle),
      code: new FormControl(this.fermeturePonctuelle?.code)
    });
  }


  initJourFerie = (): void => {
    this.fermeturePonctuelleSvc.getJourFerie().subscribe(result => {
      this.jourFerieList = result;
    })
  }

  initPerimetreFermeture = (): void => {
    this.fermeturePonctuelleSvc.getPerimetreFermeture().subscribe(result => {
      this.perimetreFermetureList = result;
    })
  }

  closeDialog = (): void => {
    this.displayDialog = false;
  };

  onChangePerimetreFermeture = ($event: any): void => {
    this.selectedPerimetreFermetureList = $event.value;
  }

  onChangeJourFerie = (data: any): void => {
    this.selectedJourFerie = data;
    const jf = this.jourFerieList.filter(jourFerie => jourFerie.code === data)[0];
    this.selectedDatefermeture = jf.date;
    this.form.controls['libelle'].setValue(jf.libelle);
  }

  isFormValide = (): boolean => {
    return this.form.valid && this.perimetresFermeturesTag.getSelectedItems().length > 0 && !this.utilsSvc.isNullOrEmpty(this.selectedDatefermeture) && !this.utilsSvc.isNullOrEmpty(this.selectedDatefermeture);
  }

  save = (): void => {
    if (this.isFormValide()) {
      const selectedPerimetres = this.perimetresFermeturesTag.getSelectedItems();
      this.fermeturePonctuelle.idUniteProduction = this.uniteProduction.id;
      this.fermeturePonctuelle.libelle = this.form.controls['libelle'].value;
      this.fermeturePonctuelle.code = this.form.controls['code'].value;
      this.fermeturePonctuelle.dateFermeture = this.selectedDatefermeture;
      this.fermeturePonctuelle.perimetreFermetureList = selectedPerimetres.map(perimetre => perimetre.code) as any;

      this.fermeturePonctuelleSvc.saveFermeturePonctuelle(this.fermeturePonctuelle).subscribe((response) => {
        if (!this.utilsSvc.isResponseSupplierError(response)) {
          const isUpdate = this.fermeturePonctuelle.id !== null && this.fermeturePonctuelle.id !== undefined && this.fermeturePonctuelle.id !== 0;
          this.fermeturePonctuelle.id = response.one.id;
          this.fermeturePonctuelle.dateFermeture = response.one.dateFermeture;
          this.fermeturePonctuelle.perimetreFermetureList = selectedPerimetres;
          this.fermeturePonctuelleSvc.announceFermeturePonctuelleSaved(this.fermeturePonctuelle, isUpdate);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Fermeture ponctuelle enregistrée avec succès`);
        }
      })
      this.closeDialog();
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  };


}
